import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker';
import React, { Component } from 'react';
import TableView from './tableView';
import AveragePackageShipmentGraphView from './averagePackageShipmentGraphView';
import HistogramByCountryView from './shipmentHistogramByCountryView';
import HistogramBySourceView from './shipmentHistogramBySourceView';
import PageTitle from './../../component/pageTitle'
import SeriesShipmentByDayGraphView from './seriesShipmentByDayGraphView';
import SeriesShipmentByMonthGraphView from './seriesShipmentByMonthGraphView';

class Dashboard extends Component {
    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Shipment Statistics Page"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <TableView></TableView>
                    <div className="graph-border-without-left-margin">
                        <HistogramBySourceView></HistogramBySourceView>
                    </div>
                </div>
                <div className="graph-border">
                    <HistogramByCountryView></HistogramByCountryView>
                </div>
                <div className="graph-border">
                    <AveragePackageShipmentGraphView></AveragePackageShipmentGraphView>
                </div>
                <div className="graph-border">
                    <SeriesShipmentByDayGraphView></SeriesShipmentByDayGraphView>
                </div>
                <div className="graph-border">
                    <SeriesShipmentByMonthGraphView/>
                </div>
            </div>
        );
    }
}

export default Dashboard;